import type {NationalAgent, NationalAgentType} from 'api/types';

export const createEmptyNationalAgent = (
  agentType: NationalAgentType,
): NationalAgent =>
  ({
    agentType,
  }) as NationalAgent;
